import React, { ReactElement } from 'react';

export const NotFound = (): ReactElement => {
  return <div>お探しのページが見つかりませんでした</div>;
};
